import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import JobScheduleAddFenceQuestionsData from './JobScheduleAddFencingQuestions';
import { GetQuery } from './Shared';

interface JobQuoteBraceProps {
    statusId: number;
    showModal: boolean;
    hideModal(): void;
    save(fenceQuantity: number, braceQuantity: number, fenceBraceId: number, note: string, fenceArea: string): void;
}

interface FenceQuestions {
    fenceTotalMetres: number;
    treeProtection: boolean;
    highWindArea: boolean;
    shadeClothAdded: boolean;
    signageAdded: boolean;
    signagePanels: number;
    fenceAreas: FenceAreaOption[];
}

interface FenceAreaOption {
    id: number;
    name: string;
    selected: boolean;
}

const JobQuoteBraceModal = (props: JobQuoteBraceProps) => {
    const [loading, setLoading] = React.useState(true);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [fenceQuestions, setFenceQuestions] = React.useState<FenceQuestions>({
        fenceTotalMetres: 0,
        treeProtection: false,
        highWindArea: false,
        shadeClothAdded: false,
        signageAdded: false,
        signagePanels: 0,
        fenceAreas: []
    });
    const [initFenceAreas, setInitFenceAreas] = React.useState<FenceAreaOption[]>([]);
    const [braces, setBraces] = React.useState(0);

    React.useEffect(() => {
        if (props.showModal) {
            getData();
        }
    }, [props.showModal]);

    const getData = async () => {
        const apiUrl = "GetJobFenceArea";
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setInitFenceAreas(result.data);
            setFenceQuestions(prevState => ({ ...prevState, fenceAreas: result.data }));
            setBraces(0);
            setLoading(false);
        }
    }

    const hideModal = () => {
        resetScreen();
        props.hideModal();
    }

    const resetScreen = () => {
        setErrors({});
        setFenceQuestions({
            fenceTotalMetres: 0,
            treeProtection: false,
            highWindArea: false,
            shadeClothAdded: false,
            signageAdded: false,
            signagePanels: 0,
            fenceAreas: initFenceAreas
        });
    }

    const deleteError = (errorName: string) => {
        var errorList = errors;
        delete errorList[errorName];
        setErrors(errorList);
    }

    const updateFenceTotalMetres = (totalMetres: number) => {
        deleteError("fenceTotalMetres");
        setFenceQuestions(prevState => ({ ...prevState, fenceTotalMetres: totalMetres }));
    }

    const updateFencingQuestion = (questionName: string, questionValue: boolean) => {
        deleteError(questionName);
        setFenceQuestions(prevState => ({ ...prevState, [questionName]: questionValue }));
        if (questionName === "signageAdded" && !questionValue) {
            setFenceQuestions(prevState => ({ ...prevState, signagePanels: 0 }));
        }
    }

    const updateSignagePanels = (panels: number) => {
        deleteError("signagePanels");
        setFenceQuestions(prevState => ({ ...prevState, signagePanels: panels }));
    }

    const updateFenceArea = (checked: boolean, itemIndex: number) => {
        deleteError("fenceArea");
        let fenceAreas = [...fenceQuestions.fenceAreas];
        let fenceArea = fenceAreas[itemIndex];
        fenceArea.selected = checked;
        if (fenceArea.id === 1) {
            //full boundry selected so untick the others
            let otherAreas = fenceAreas.filter(f => f.id != 1 && f.selected);
            for (var i = 0; i < otherAreas.length; i++) {
                otherAreas[i].selected = false;
            }
        }

        setFenceQuestions(prevState => ({ ...prevState, fenceAreas: fenceAreas }));
    }

    //TODO call this when the fencing questions are updated - add useEffect
    //const calculateBracesRecommended = (totalMetres: number, highWind: number, shadeCloth: number, signPanels: number) => {
    //    if (totalMetres === 0) {
    //        setBraces(0);
    //    } else {
    //        let braceId = highWind === 1 && shadeCloth === 1 ? 1 : highWind === 0 && shadeCloth === 1 ? 2 : highWind === 1 && shadeCloth === 0 ? 3 : 0;
    //        if (braceId > 0) {
    //            //calculate brace qty
    //            var quantity = (totalMetres / 2.4) / braceId;
    //            let qty = Math.trunc(quantity);
    //            if (braceId != 1) {
    //                //add extra panels for signage. Brace Id 1 is every panel so don't need to add extra
    //                qty += signPanels;
    //            }
    //            setBraces(qty);
    //        } else {
    //            setBraces(signPanels);
    //        }
    //    }
    //}

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        if (fenceQuestions.fenceTotalMetres <= 0) {
            formIsValid = false;
            errorList["fenceTotalMetres"] = "Fence Total Metres is required";
        }

        if (fenceQuestions.signageAdded && fenceQuestions.signagePanels <= 0) {
            formIsValid = false;
            errorList["signagePanels"] = "# Panels with Signs is required";
        }

        let fenceAreasSelected = fenceQuestions.fenceAreas.filter(f => f.selected);
        if (fenceAreasSelected.length === 0) {
            formIsValid = false;
            errorList["fenceArea"] = "At least one Fence Area is required";
        }

        setErrors(errorList);
        return formIsValid;
    }

    const save = (e: any) => {
        e.preventDefault();

        if (validate()) {
            //calculate brace qty
            let totalFenceQty = fenceQuestions.fenceTotalMetres;
            let braceQty = 0;

            let braceId = fenceQuestions.highWindArea && fenceQuestions.shadeClothAdded ? 1 : fenceQuestions.shadeClothAdded ? 2 : fenceQuestions.highWindArea ? 3 : -1;
            if (braceId > 0) {
                //calculate brace qty
                var quantity = (totalFenceQty / 2.4) / braceId;
                braceQty = Math.trunc(quantity);
                if (braceId != 1) {
                    braceQty += fenceQuestions.signagePanels;
                }
            } else {
                braceId = 4;
                braceQty = fenceQuestions.signagePanels;
            }

            let fencePanelNote = fenceQuestions.signageAdded && fenceQuestions.signagePanels > 0 ? ", Signs Added to " + fenceQuestions.signagePanels + " panels" : "";
            let fenceNote = "Fence Total Metres: " + fenceQuestions.fenceTotalMetres;
            if (fenceQuestions.treeProtection) {
                fenceNote += ", Tree Protection: Yes";
            }
            if (fenceQuestions.highWindArea) {
                fenceNote += ", High Wind Area: Yes";
            }
            if (fenceQuestions.shadeClothAdded) {
                fenceNote += ", Shade Cloth: Yes";
            }
            if (fenceQuestions.signageAdded) {
                fenceNote += ", Signs Added to Fence: Yes";
            }
            fenceNote += fencePanelNote;

            let fenceAreaNote = "";
            for (var i = 0; i < fenceQuestions.fenceAreas.length; i++) {
                if (fenceQuestions.fenceAreas[i].selected) {
                    fenceAreaNote += fenceAreaNote != "" ? ", " + fenceQuestions.fenceAreas[i].name : fenceQuestions.fenceAreas[i].name;
                }
            }
            if (fenceAreaNote != "") {
                fenceNote += " Fence Area: " + fenceAreaNote;
            }

            //reset screen
            resetScreen();

            props.save(totalFenceQty, braceQty, braceId, fenceNote, fenceAreaNote);
        }
    }

    const fencingQuestions = <JobScheduleAddFenceQuestionsData fencingQuestions={fenceQuestions} braces={braces} errors={errors} updateTotalMetres={updateFenceTotalMetres} updateFencingQuestion={updateFencingQuestion} updateSignagePanels={updateSignagePanels} updateFenceArea={updateFenceArea} />

    const renderDetails = (
        <Modal show={props.showModal} onHide={hideModal}>
            <Modal.Header className="modal__header--colour">
                <Modal.Title>Calculate Braces Required</Modal.Title>
                <button type="button" className="close" onClick={hideModal}>&times;</button>
            </Modal.Header>
            <Modal.Body>
                {fencingQuestions}
            </Modal.Body>
            <Modal.Footer>
                <button className={props.statusId === 1 || props.statusId === 2 || props.statusId === 3 ? "popup-button--yes" : "hidden"} onClick={save}>Save</button>
            </Modal.Footer>
        </Modal>
    );


    let contents = props.showModal && loading
        ? <p><em>Loading...</em></p>
        : props.showModal ? renderDetails : <div></div>;

    return (
        <div>
            {contents}
        </div>
    )

}

export default JobQuoteBraceModal;